import cn from 'classnames';
import React, {
    forwardRef, useEffect, useImperativeHandle, useRef,
} from 'react';

import {
    TPredicateExpressionGroupTuple,
    TPredicateExpressionCreatorRef,
    IPredicateExpressionGroupRef,
} from 'features/predicate-expression-form-list';

import {DdRestrictionExpressionGroup} from './dd-restriction-expression-group';

interface IDdRestrictionsExpressionCreatorProps {
    initialExpression?: TPredicateExpressionGroupTuple;
    className?: cn.Argument;
    isEditing: boolean;
}

export const DdRestrictionExpressionCreator = forwardRef<
    TPredicateExpressionCreatorRef,
    IDdRestrictionsExpressionCreatorProps
>(({
    initialExpression,
    className,
    isEditing,
}: IDdRestrictionsExpressionCreatorProps, ref) => {
    const expressionRef = useRef<IPredicateExpressionGroupRef>(null);

    const getValuesToSave = () => expressionRef.current?.getValues() as Promise<TPredicateExpressionGroupTuple>;
    const setExpression = expressionRef.current?.setExpression;

    useImperativeHandle(ref, () => ({
        getValuesToSave,
        setExpression,
    }));

    useEffect(() => {
        if (initialExpression) setExpression?.(initialExpression);
    }, [initialExpression]);

    return (
        <div className={cn('dd-filter-expression-creator')}>
            <DdRestrictionExpressionGroup
                ref={expressionRef}
                initialExpression={initialExpression ?? [{connectBy: 'OR'}]}
                className={className}
                isEditing={isEditing}
                depth={0}
                itemIndex="1"
            />
        </div>
    );
});
